const documentHeight = () => {
	const doc = document.documentElement;
	// console.log(window.innerHeight)
	doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", documentHeight);

window.addEventListener("DOMContentLoaded", documentHeight);
	documentHeight();

document.addEventListener("DOMContentLoaded", (event) => {
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (!links[i].classList.contains("didomi") && links[i].hostname !== window.location.hostname) {
			links[i].target = "_blank";
			links[i].rel = "noreferrer noopener";
		}
	}
});

/**
 * Toggle the mobile menu.
 */
function mmMobileMenu() {
    if (window.innerWidth <= 1250) {
        const filter = document.querySelector('.mm-filter-mega-menu');
        const header = document.querySelector("header");
        const icon = document.querySelector(".mm-header-burger");
        const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");


		filter.classList.add("active");
		header.classList.toggle("mm-open");
		icon.classList.toggle("mm-open");
		mobileMenu.classList.toggle("mm-menu-open");
		document.querySelector("html").classList.toggle("stop-scrolling");
	}
}

function toggleSubMenu(element, show) {
	const submenu = element.querySelector('.mm-header-secondary-wrapper');
	const filter = document.querySelector('.mm-background-filter');

	if (show) {
	  submenu.classList.toggle("mm-open");
	  filter.classList.add("mm-active");
	} else {
	  submenu.classList.remove('mm-open');
	  filter.classList.remove('mm-active');
	}
  }

/**
 * Close the mobile menu.
 */
function mmCloseMobileMenu() {
	if (window.innerWidth <= 1250) {
		const header = document.querySelector("header");
		const icon = document.querySelector(".mm-header-burger");
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

		header.classList.remove("mm-open");
		icon.classList.remove("mm-open");
		document.querySelector("html").classList.toggle("stop-scrolling");
		mobileMenu.classList.remove("mm-menu-open");
	}
}

// Menu mobile dropdowns

function animatedDropdowns() {
	const dropdowns = document.querySelectorAll(".mm-dropdown");
	//     if (dropdowns.length > 0) {
	//     dropdowns[0].classList.add('mm-active');
	//     dropdowns[0].nextElementSibling.style.maxHeight = dropdowns[0].nextElementSibling.scrollHeight + 'px';
	// }

	dropdowns.forEach((dropdown) => {
		dropdown.addEventListener("click", function () {
			dropdowns.forEach((el) => {
				if (el !== this) {
					el.classList.remove("mm-active");
					el.nextElementSibling.style.maxHeight = null;
				}
			});
			this.classList.toggle("mm-active");
			const content = this.nextElementSibling;
			if (this.classList.contains('mm-active')) {
        content.style.maxHeight = content.scrollHeight + "px";
			} else {
				content.style.maxHeight = "0px";
			}
		});
	});
}

window.addEventListener("DOMContentLoaded", (event) => {
	animatedDropdowns();
});

//Open & close search mobile

const SEARCHMOBILE = document.querySelector(".mm-header-search-mobile");

function mmOpenSearchMobile() {
	SEARCHMOBILE.classList.add("mm-open");
}

function mmCloseMobilesearch() {
	SEARCHMOBILE.classList.remove("mm-open");
}


// Filter mega menu hover
const menus = document.querySelectorAll('.mm-header-menu');
const backgroundFilter = document.querySelector('.mm-background-filter');

function showBackgroundFilter() {
    backgroundFilter.classList.add('mm-active');
}

function hideBackgroundFilter() {
    backgroundFilter.classList.remove('mm-active');
}

menus.forEach(menu => {
    menu.addEventListener('mouseenter', showBackgroundFilter);
    menu.addEventListener('mouseleave', hideBackgroundFilter);
});


// Close search mobile modal
document.addEventListener('DOMContentLoaded', function () {
    const closeModalBtn = document.querySelector('.mm-close-search-modal');
    const modal = document.querySelector('.mm-header__search');
    const detailsModal = modal.children[0];
    const secondaryMenu = document.querySelector('.mm-header-secondary-menu');

    // Observer les changements de l'attribut 'open' du detailsModal
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'open') {
                if (detailsModal.open) {
                    secondaryMenu.style.display = 'none';
                } else {
                    secondaryMenu.style.display = '';
                }
            }
        });
    });

    // Configuration de l'observer
    observer.observe(detailsModal, { attributes: true });

    closeModalBtn.addEventListener('click', function() {
        detailsModal.open = false;
    });

    document.addEventListener('click', function(event) {
        if (!modal.contains(event.target) && detailsModal.open) {
            detailsModal.open = false;
        }
    });
});



// Second level mobile menu top header btn clickable

document.addEventListener('DOMContentLoaded', function () {
const headerBurger = document.querySelector('.mm-header-burger');
const headerLeft = document.querySelector('.mm-header-left');
const headerCenter = document.querySelector('.mm-header-center');
const headerRight = document.querySelector('.mm-header-right')


	headerBurger.addEventListener('click', function() {
		headerLeft.style.zIndex = "5";
		headerCenter.style.zIndex = "5";
		headerRight.style.zIndex = "5";
	});
});

// DROPDOWN **********************************************************************************
/*********************************************************************************************
* Handle dropdown behavior.
	*
*/
const handleDropdown = () => {
    const dropContainers = document.querySelectorAll(".mm-dropdown-container");

    dropContainers.forEach((dropContainer, index) => {
        const dropWrappers = dropContainer.querySelectorAll('[data-drop="dropdown"]');

        dropWrappers.forEach((item, i) => {
            const content = item.nextElementSibling;
            const chevronIcon = item.querySelector('.mm-chevron-mobile-menu');  // Récupère l'icône chevron

            // Ouvre uniquement le premier dropdown par défaut avec transition
            if (index === 0 && i === 0 && !dropContainer.hasAttribute('data-dropdown-closed')) {
                item.classList.add("active");
                if (content) {
                    content.style.maxHeight = `${content.scrollHeight}px`;
                    content.style.visibility = "visible";
                    content.style.transition = "max-height 0.3s ease-in-out, visibility 0.3s ease-in-out";
                }
                if (chevronIcon) {
                    chevronIcon.classList.add("rotate");  // Ajoute la rotation sur le premier dropdown
                }
            } else {
                if (content) {
                    content.style.maxHeight = "0";
                    content.style.visibility = "hidden";
                    content.style.transition = "max-height 0.3s ease-in-out, visibility 0.3s ease-in-out";
                }
                if (chevronIcon) {
                    chevronIcon.classList.remove("rotate");  // Retire la rotation sur les autres
                }
            }

            item.addEventListener("click", function () {
                console.log(item);

                dropWrappers.forEach((el) => {
                    if (el !== this) {
                        el.classList.remove("active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.style.maxHeight = "0";
                            el.nextElementSibling.style.visibility = "hidden";
                        }
                    }
                });

                this.classList.toggle("active");
                if (content) {
                    if (this.classList.contains("active")) {
                        content.style.maxHeight = `${content.scrollHeight}px`;
                        content.style.visibility = "visible";
                    } else {
                        content.style.maxHeight = "0";
                        content.style.visibility = "hidden";
                    }
                }

                // Gère la rotation de l'icône au clic
                if (chevronIcon) {
                    chevronIcon.classList.toggle("rotate");
                }
            });
        });
    });
};

  // DOM ***************************************************************************************
/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener('DOMContentLoaded', () => {
    handleDropdown();
});



/* Accordions */
document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('[data-accordion-toggle]');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      console.log('click')
      const targetId = toggle.getAttribute('data-accordion-toggle');
      const content = document.querySelector(`[data-accordion-content="${targetId}"]`);

      if (!content) return;

      // Toggle class
      const isOpen = content.classList.contains('open');

      // Close all others
      document.querySelectorAll('[data-accordion-content]').forEach(el => {
        el.classList.remove('open');
        el.style.maxHeight = null;
      });

      // Open the selected one if it was closed
      if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  const elemsToOpenOnLoad = document.querySelectorAll('[data-open-on-load]');
  elemsToOpenOnLoad.forEach(function(elem) {
    const clickEvent = new Event('click');
    elem.dispatchEvent(clickEvent);
  })
});


/*********************************************************************************************
* Custom element for product recommendations
	*
*/
class ProductRecommendations extends HTMLElement {
     constructor() {
         super();
     }

     connectedCallback() {
         const handleIntersection = (entries, observer) => {
             if (!entries[0].isIntersecting) return;
             observer.unobserve(this);

             fetch(this.dataset.url)
                 .then((response) => response.text())
                 .then((text) => {
                     const html = document.createElement("div");
                     html.innerHTML = text;
                     const recommendations = html.querySelector("product-recommendations");

                     if (recommendations && recommendations.innerHTML.trim().length) {
                         this.innerHTML = recommendations.innerHTML;
                     } else {
                         const parentElement = this.closest('.mm-section');
                         if (parentElement) {
                             parentElement.style.display = 'none';
                         }
                     }
                 })
                 .catch((e) => {
                     console.error(e);
                 });
         };

         new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
     }
 }

 customElements.define("product-recommendations", ProductRecommendations);

/**
 * Push a dataLayer event when a menu link is clicked (menu_entry)
 * or when a mobile accordion is opened (menu_open).
 */
function mmPushMenuEvent(eventName, element) {
	const entry = {
		event: eventName,
		menu_item: element.dataset.menuItem,
		menu_level: parseInt(element.dataset.menuLevel, 10),
		menu_path: element.dataset.menuPath,
		menu_location: element.dataset.menuLocation
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(entry);
}

document.addEventListener("click", function (event) {
	const link = event.target.closest("a[data-menu-path]");
	if (link) {
		mmPushMenuEvent("menu_entry", link);
		return;
	}

	const header = event.target.closest("[data-menu-open]");
	if (!header) return;

	let opening;
	if (header.tagName === "SUMMARY") {
		opening = !header.parentElement.open;
	} else {
		opening = header.classList.contains("active");
	}
	if (opening) {
		mmPushMenuEvent("menu_open", header);
	}
});
